import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';

const extractUrlParams = (
  keys: DeeplinkKeys[]
): Partial<Record<DeeplinkKeys, string>> => {
  const { params } = getContext().general.location.getState();

  return keys.reduce<Record<string, string>>((acc, key) => {
    const value = params[key] as string;
    return value ? { ...acc, [key]: value } : acc;
  }, {});
};

export { extractUrlParams };
